








import { Vue, Component } from "vue-property-decorator";
import MainMenu from "@/components/MainMenu.vue";
import auth from "@/store/modules/auth";
import firebase from "firebase";
import TabNavigation from "@/components/TabNavigation.vue";
import Trip from "@/views/Trip.vue";
import Home from "@/views/Home.vue";
import { db } from "@/main";

@Component({
  components: {
    MainMenu,
    Trip,
    Home
  }
})
export default class App extends Vue {

  get isAuthenticated() : boolean {
    console.log('Is Authenticated? ' + auth.isAuthenticated);
    return auth.isAuthenticated;
  }

  created() {
    /*if (messaging) {
      messaging.onMessage((payload) => {
        console.log(payload);
        this.$ionic.toastController.create({message: "Test Message"}).then(t => t.present);
      })
    }*/
  }
}
